import { NavLink } from "react-router-dom";
import Container from "../../Atoms/layouts/container/Container";
import Logo from "../../Atoms/logo/logo";
import style from "./Footer.module.scss";
import { socialProfiles } from "../../../static_data/page_data";

const FOOTER_NAV = {
  company: [
    { label: "About Us", to: "/about-us" },
    { label: "Careers", to: "/careers" },
    { label: "Contact Us", to: "/contact" },
    { label: "Blogs", to: "/blogs" },
  ],
  services: [
    { label: "Services", to: "/services" },
    { label: "IT Consulting", to: "/services/it-consulting" },
    { label: "Research and Analytics", to: "/services/research-analytics" },
    { label: "Public Sector", to: "/services/public-sector" },
    { label: "Online Training", to: "/services/online-training" },
    { label: "Enterprise Partners", to: "/services/enterprise-partners" },
  ],
  products: [
    { label: "AI Hub", to: "/ai-hub" },
    { label: "Learning", to: "/education" },
    { label: "Research", to: "/lushai-analytics" },
  ],
};

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className={style.Footer} role="contentinfo">
      <Container>
        <div className={style.grid}>
          <div className={style.brandCol}>
            <NavLink to="/" aria-label="LushAITech home">
              <div className={style.logo}>
                <Logo />
              </div>
            </NavLink>
            <ul className={style.social} aria-label="Social media">
              {socialProfiles.map((profile) => (
                <li key={profile.id}>
                  <a
                    href={profile.link}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={profile.site}
                  >
                    <ion-icon name={profile.icon}></ion-icon>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className={style.linkCol}>
            <h3 className={style.colTitle}>Company</h3>
            <ul>
              {FOOTER_NAV.company.map((link) => (
                <li key={link.to}>
                  <NavLink to={link.to}>{link.label}</NavLink>
                </li>
              ))}
            </ul>
          </div>

          <div className={style.linkCol}>
            <h3 className={style.colTitle}>Services</h3>
            <ul>
              {FOOTER_NAV.services.map((link) => (
                <li key={link.to}>
                  <NavLink to={link.to}>{link.label}</NavLink>
                </li>
              ))}
            </ul>
          </div>

          <div className={style.linkCol}>
            <h3 className={style.colTitle}>Products & Research</h3>
            <ul>
              {FOOTER_NAV.products.map((link) => (
                <li key={link.to}>
                  <NavLink to={link.to}>{link.label}</NavLink>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className={style.bottom}>
          <p>&copy;{year}, All rights reserved</p>
          <ul className={style.legal}>
            <li>
              <NavLink to="/contact">Contact Us</NavLink>
            </li>
          </ul>
        </div>
      </Container>
    </footer>
  );
}
